import angular = require("angular");
import TPL = require("templates");
import {Config} from "../../config";

/**
  Site logo
  params:
    linkHome: boolean, if true go to the homepage when clicked
*/
export class LogoDirective {

  scope = {
    params: "=params"
  };

  template = TPL.commonDirectives.logo;
  link;

  constructor($location) {
    this.link = (scope, el, attrs) => {
        scope.vm = {
          goHome: () => {
            /*switch(Config.isOnward) {
              case true:
                window.location.href = Config.wp_onward_home;
                break;
              case false:*/
                window.location.href = Config.wp_home;
                //break;
            //}
          },
          isClickable: () => {
            return scope.params && scope.params.linkHome;
          },
          click: () => {
            if (scope.vm.isClickable()) {
              scope.vm.goHome();
            }
          },
          getImageClass: () => {

            var logoClass: string;

            if (!Config.isOnward) {
              switch(scope.params.type) {
                case "footer":
                  logoClass = "ot-logo-footer";
                  break;
                case "emblem":
                  logoClass = "ot-logo-emblem";
                  break;
                case "vertical":
                  logoClass = "ot-logo-vertical";
                  break;
                case "header":
                default:
                  logoClass = "ot-logo-header";
              }
            } else {
              switch(scope.params.type) {
                case "footer":
                  logoClass = "ot-logo-onward";
                  break;
                case "emblem":
                  logoClass = "ot-logo-emblem";
                  break;
                case "vertical":
                  logoClass = "ot-logo-onward-vertical";
                  break;
                case "header":
                default:
                  logoClass = "ot-logo-onward";
                }
            }

            return logoClass;
          }
        };
    }
  }

  static factory() {
    var tmp = (a) => new LogoDirective(a);
    tmp.$inject = ["$location"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/common/logo.ts
 **/